import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=98fff01a&"
import script from "./ContactList.vue?vue&type=script&lang=ts&"
export * from "./ContactList.vue?vue&type=script&lang=ts&"
import style0 from "./ContactList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports